import { PastaBox } from "@pasta/box-v2";
import { routes } from "./routes";

export class VersionAnnouncementBox extends PastaBox {
  setup(): void {
    this.setupRoutes({ routes });
  }
}
